import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

function DoseCell({ label, k, v, onSet }) {
  return (
    <div className="flex flex-col items-center gap-2.5 rounded-xl bg-[#F7F4EC]/60 border border-[#EFECE5] p-3">
      <div className="text-sm font-semibold text-[#1F2A24]" style={{ fontFamily: "Instrument Sans" }}>{label}</div>
      <div className="flex gap-1.5">
        {[0, 1, 2, 3].map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onSet(k, n)}
            data-testid={`dose-${k}-${n}`}
            className={`w-9 h-9 rounded-lg text-sm font-semibold border transition-colors ${
              v[k] === n ? "bg-[#0A4C36] text-white border-[#0A4C36]" : "bg-white text-[#1F2A24] border-[#E8E6E1] hover:border-[#0A4C36]/40"
            }`}
          >{n}</button>
        ))}
      </div>
    </div>
  );
}

/**
 * DoseDialog — Morning / Afternoon / Night pickers.
 * Value = {morning, afternoon, night}. Integers 0..3 (screenshot shows 0/1 toggle; we allow 0-3 for flexibility).
 */
export default function DoseDialog({ open, onOpenChange, value, onChange }) {
  const v = value || { morning: 0, afternoon: 0, night: 0 };
  const set = (k, n) => onChange({ ...v, [k]: n });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[24px] max-w-lg sm:max-w-xl" data-testid="dose-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg text-[#0A4C36]" style={{ fontFamily: "Instrument Sans" }}>Dose</DialogTitle>
          <DialogDescription className="text-xs text-[#6C7B72]">Tap the count for morning, afternoon and night. 0 skips that dose.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 py-2">
          <DoseCell label="Morning" k="morning" v={v} onSet={set} />
          <DoseCell label="Afternoon" k="afternoon" v={v} onSet={set} />
          <DoseCell label="Night" k="night" v={v} onSet={set} />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button className="btn-outline-emerald" onClick={() => onOpenChange(false)} data-testid="dose-cancel">Cancel</button>
          <button className="btn-emerald" onClick={() => onOpenChange(false)} data-testid="dose-save">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
